import { z } from 'zod'

export const httpUrlSchema = z.url().refine((val) => /^https?:\/\//i.test(val), {
  message: 'URL must use http or https scheme',
})
